var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"start-up"}},[_c('div',{class:_vm.isLogo ? 'logo logo-active' : 'logo'},[(!_vm.isLogo)?_c('img',{staticClass:"logoimg",attrs:{"src":require("../../assets/images/loginLogo.png"),"alt":""}}):_vm._e(),_c('img',{staticClass:"logo1",attrs:{"src":require("../../assets/images/loginLogo.png"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }